import React from 'react';
import { Container, Typography, Accordion, AccordionSummary, AccordionDetails, Box, Paper, Divider } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const PrivacyContainer = () => {
  return (
    <Container sx={{ py: { xs: 10, md: 12 } }}>
      <Paper elevation={0} sx={{ p: { xs: 2, sm: 4 }, backgroundColor: '#f9f9f9', borderRadius: 2 }}>
        
        <Typography variant="h4" component="h1" gutterBottom fontWeight="bold" textAlign="center">
          Политика конфиденциальности
        </Typography>
        <Typography variant="body2" color="text.secondary" textAlign="center" gutterBottom>
          Дата последнего обновления: 23 апреля 2026 г.
        </Typography>
        
        <Divider sx={{ my: 3 }} />
        
        {/* <Typography variant="body1" paragraph>
          Настоящая Политика конфиденциальности (далее — Политика) регулирует порядок обработки и защиты 
          персональных данных пользователей сайта Центра профессионального развития (далее — Центр, Оператор).
        </Typography> */}

        {/* БЛОК ПРО ЯНДЕКС МЕТРИКУ — самый важный и понятный */}
        <Box sx={{ mb: 4, p: 3, bgcolor: '#e8f4f8', borderRadius: 2 }}>
          <Typography variant="h5" gutterBottom fontWeight="bold" color="#0066cc">
            📊 Как мы используем данные
          </Typography>
          <Typography variant="body1" paragraph>
            К сайту подключён счётчик Яндекс.Метрики. Он считает, сколько людей зашло, какие страницы открывали, 
            с компьютера или телефона. Это нужно, чтобы мы понимали, что вам интересно, и делали сайт удобнее.
          </Typography>
          <Typography variant="body1" paragraph>
            Мы специально не собираем ваше имя, телефон, адрес и другие личные данные. 
            Единственное, что передаётся технически — это IP-адрес, но он используется только в обезличенном виде 
            для статистики и не позволяет вас идентифицировать. Мы видим только «кто-то зашёл», но не знаем, кто именно.
          </Typography>
          <Typography variant="h6" gutterBottom fontWeight="bold">
            Можно ли отказаться?
          </Typography>
          <Typography variant="body1" paragraph>
            Да. Вы можете отключить cookie в настройках вашего браузера — это запретит сбор данных на всех сайтах.
          </Typography>
          {/* <Typography variant="body2" color="text.secondary" sx={{ mt: 1, fontStyle: 'italic' }}>
            * При первом заходе мы показываем уведомление с кнопкой «Согласен». Если вы не нажмёте её — счётчик не включится.
          </Typography> */}
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* 1. Какие данные мы собираем */}
        <Accordion defaultExpanded sx={{ mb: 2, '&:before': { display: 'none' } }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6" component="span" fontWeight="medium">1. Какие данные мы собираем</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2" paragraph>
              Оператор собирает только обезличенные статистические данные через Яндекс.Метрику:
            </Typography>
            <Box component="ul" sx={{ mt: 0, pl: 2 }}>
              <li><Typography variant="body2">IP-адрес (в обезличенном виде, не позволяет идентифицировать пользователя)</Typography></li>
              <li><Typography variant="body2">Тип устройства (компьютер/телефон/планшет)</Typography></li>
              <li><Typography variant="body2">Операционная система и браузер</Typography></li>
              <li><Typography variant="body2">Посещённые страницы и время на сайте</Typography></li>
              <li><Typography variant="body2">Файлы cookie, необходимые для работы счётчика</Typography></li>
            </Box>
            <Typography variant="body2" sx={{ mt: 2 }}>
              Мы <strong>не собираем</strong> ваше имя, телефон, адрес, паспортные данные, банковскую информацию или любые другие данные, которые могут вас идентифицировать лично.
            </Typography>
          </AccordionDetails>
        </Accordion>

        {/* 2. Как мы используем ваши данные */}
        <Accordion sx={{ mb: 2, '&:before': { display: 'none' } }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6" component="span" fontWeight="medium">2. Как мы используем данные</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2" paragraph>
              Собранные данные используются исключительно для:
            </Typography>
            <Box component="ul" sx={{ mt: 0, pl: 2 }}>
              <li><Typography variant="body2">Анализа посещаемости сайта</Typography></li>
              <li><Typography variant="body2">Понимания, какие страницы и материалы наиболее интересны пользователям</Typography></li>
              <li><Typography variant="body2">Выявления технических проблем и улучшения работы сайта</Typography></li>
              <li><Typography variant="body2">Оптимизации сайта под разные устройства (адаптивный дизайн)</Typography></li>
            </Box>
            <Typography variant="body2" sx={{ mt: 2 }}>
              Данные никогда не передаются третьим лицам для рекламы или других целей, не указанных выше.
            </Typography>
          </AccordionDetails>
        </Accordion>

        {/* 3. Передача данных третьим лицам */}
        <Accordion sx={{ mb: 2, '&:before': { display: 'none' } }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6" component="span" fontWeight="medium">3. Передача данных третьим лицам</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2">
              Данные передаются только компании ООО «Яндекс» (владельцу сервиса Яндекс.Метрика) в обезличенном виде 
              для формирования статистики. Яндекс обрабатывает эти данные в соответствии со своей 
              <a href="https://yandex.ru/legal/confidential/" target="_blank" rel="noopener noreferrer"> Политикой конфиденциальности</a>. 
              Мы не передаём ваши данные другим третьим лицам.
            </Typography>
          </AccordionDetails>
        </Accordion>

        {/* 4. Сроки хранения данных */}
        <Accordion sx={{ mb: 2, '&:before': { display: 'none' } }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6" component="span" fontWeight="medium">4. Сроки хранения данных</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2">
              Данные Яндекс.Метрики хранятся не более 12 месяцев. После этого они автоматически удаляются или обезличиваются. 
              Вы также можете самостоятельно очистить cookie в настройках браузера в любой момент.
            </Typography>
          </AccordionDetails>
        </Accordion>

        {/* 5. Ваши права */}
        <Accordion sx={{ mb: 2, '&:before': { display: 'none' } }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6" component="span" fontWeight="medium">5. Ваши права</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2" paragraph>
              В соответствии с 152-ФЗ «О персональных данных», вы имеете право:
            </Typography>
            <Box component="ul" sx={{ mt: 0, pl: 2 }}>
              <li><Typography variant="body2">Отказаться от сбора данных, отключив cookie в настройках браузера</Typography></li>
              <li><Typography variant="body2">Запросить информацию об обработке ваших данных</Typography></li>
              <li><Typography variant="body2">Потребовать удаления данных, если они собираются с нарушением закона</Typography></li>
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* 6. Контакты */}
        <Accordion sx={{ mb: 2, '&:before': { display: 'none' } }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6" component="span" fontWeight="medium">6. Контактная информация</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2" paragraph>
              По всем вопросам, связанным с обработкой данных, вы можете обратиться:
            </Typography>
            <Typography variant="body2">
              📍 Адрес: г. Томск, ул. Смирнова, 28 ст.1<br />
              📞 Телефон: +7 (3822) 90-11-73<br />
              ✉️ Email: cpc@education70.ru
            </Typography>
          </AccordionDetails>
        </Accordion>

        {/* 7. Изменения */}
        <Accordion sx={{ '&:before': { display: 'none' } }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6" component="span" fontWeight="medium">7. Изменение политики конфиденциальности</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2">
              Оператор оставляет за собой право вносить изменения в настоящую Политику. 
              Актуальная версия всегда доступна по этому адресу. Продолжая использовать сайт, 
              вы подтверждаете согласие с действующей редакцией Политики.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Paper>
    </Container>
  );
}

export default PrivacyContainer;

// import React from 'react';
// import { Container, Typography, Accordion, AccordionSummary, AccordionDetails, Box } from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// const FaqContainer = () => {
//   return (
//     <>
//         <Container style={{paddingTop: "100px", paddingBottom: "50px"}}>
            
//         </Container>
        
//   </>
//   );
// }

// export default FaqContainer;